import { useQuery } from '@tanstack/react-query';
import SupportAllowedType from '../models/supportAllowedType';
import useRestService from '../shared/rest-service';

export function useSupportTypes(type: 'organizations' | 'request-types') {
  const { fetchWrapper } = useRestService();

  return useQuery<SupportAllowedType[], Error>(['support-allowed-type', type], () => {
    return fetchWrapper(`api/management/support/${type}`);
  });
}
